module.exports = __webpack_public_path__ + "static/media/dsr_bg2.11d76311.png";